@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.error-msg {
	color: Colors.$col-red;
	font-weight: bold;
	width: 100%;
	font-size: Constants.$val-fontSizeRegular;
}